import React, {Fragment} from 'react';
import {AlertModal} from 'presentation/components/AlertModal';
import {translations} from 'presentation/translations-new';
import {EarlyAccessModalProps} from './types';

const {title, description, buttonLabel, headerTitle} =
	translations['pt-br'].privateFlow.guideFlow.earlyAccessModal;

export function EarlyAccessModal({open, onClose, dtAdesao}: EarlyAccessModalProps) {
	return (
		<AlertModal
			open={open}
			onClose={onClose}
			variant="info"
			headerTitle={headerTitle}
			title={title}
			description={
				<Fragment>
					{description.part1} <strong>{dtAdesao}</strong>. {description.part2}
				</Fragment>
			}
			buttonLabel={buttonLabel}
		/>
	);
}
